import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import App from 'components/layouts/App';

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      props.location.type = rest.type;

      return rest.authenticated ? (
        rest.userAcceptedTerms || props.location.pathname === '/logout' ? (
          !rest.admin || !rest.account.id || (rest.admin && rest.account.superadmin) ? (
            <App>
              <Component {...props} />
            </App>
          ) : (
            <Redirect
              to={{
                pathname: '/login',
                state: { from: props.location }
              }}
            />
          )
        ) : (
          <Redirect
            to={{
              pathname: '/legal/terms-of-service',
              state: { from: props.location }
            }}
          />
        )
      ) : (
        <Redirect
          to={{
            pathname: '/login',
            state: { from: props.location }
          }}
        />
      );
    }}
  />
);

export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/utils/router/routes/PrivateRoute.js